import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { InputStatus } from '../helpers/getFinalFieldState.types';

import {
  getWrapperColorFromStatus,
  getWrapperHoverColorFromStatus,
} from './Wrapper.helpers';

interface WrapFixProps {
  $status: InputStatus;
  $isHovered: boolean;
  $isFocused: boolean;
}
interface WrapElementProps extends WrapFixProps {
  $isRounded: boolean;
  $isFullWidth: boolean;
}

export const $WrapFix = styled.div<WrapFixProps>`
  font-weight: ${fontWeight('bold')};
  transition-duration: ${({ theme }) => theme.interactions.transformTiming};
  transition-property: color;
  padding: 0 ${spacing('md')};
  white-space: nowrap;
  color: ${({ $isHovered, $isFocused, theme, $status }) => {
    return $isHovered || $isFocused
      ? getWrapperHoverColorFromStatus({ theme, $status })
      : getWrapperColorFromStatus({ theme, $status });
  }};
`;

export const $WrapElement = styled.div<WrapElementProps>`
  width: ${({ $isFullWidth }) => ($isFullWidth ? '100%' : 'auto')};
  display: flex;
  align-items: center;
  transition-duration: 0.1s;
  border-radius: ${({ theme }) => {
    return theme.newUI.borders.mediumRadius;
  }};
  transition-property: background;
  transition-duration: ${({ theme }) => theme.interactions.transformTiming};
`;

export const $Wrapper = styled.div<{
  $isFullWidth?: boolean;
}>`
  display: flex;
  width: ${({ $isFullWidth }) => ($isFullWidth ? '100%' : 'auto')};
`;
